module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGa5d7c9c3dc560138a0c8489d1e035347.a5d7c9c3.png";